<ng-container *ngIf="slice.settings">
  <div
    *ngFor="let element of elementsRange; trackBy: trackByIndex"
    [class.selected]="currentElement === element"
    class="element">
    <div
      class="header"
      (click)="goToElement(element, 'click')"
      (mouseover)="goToElement(element, 'hover')">
      @let headerContent = slice.settings.general.headers[element];
      <div
        class="content">
        <!-- eslint-disable @angular-eslint/template/no-call-expression -->
        <img
          *ngIf="headerTypeHasIcon && headerContent.icon"
          alt="{{ headerContent.alt ?? '' }}"
          [src]="getIconSrc(headerContent.icon, expandedElements[element])"
          [attr.width]="headerContent.icon.width"
          [attr.height]="headerContent.icon.height">
        <!-- eslint-enable @angular-eslint/template/no-call-expression -->
        <render-wysiwyg
          [html]="headerContent.text ?? headerContent.alt">
        </render-wysiwyg>
      </div>
      <div class="toggle-icon">
        <ng-container *ngIf="!expandedElements[element]">
          <!-- eslint-disable @angular-eslint/template/no-call-expression -->
          <img
            *ngIf="slice.settings.general.headerIcon.iconCollapsed?.image; else defaultIconCollapsed"
            alt="Icono colapsado"
            [src]="getHeaderIconSrc(slice.settings.general.headerIcon.iconCollapsed!.image!)">
          <!-- eslint-enable @angular-eslint/template/no-call-expression -->
          <ng-template #defaultIconCollapsed>
            <svg
              viewBox="0 0 12 12"
              fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="black"
                d="M6 0.375C6.24813 0.375 6.44928 0.57615 6.44928 0.824281V5.55072H11.1757C11.4239 5.55072 11.625 5.75187 11.625 6C11.625 6.24813 11.4239 6.44928 11.1757 6.44928H6.44928V11.1757C6.44928 11.4239 6.24813 11.625 6 11.625C5.75187 11.625 5.55072 11.4239 5.55072 11.1757V6.44928H0.824281C0.57615 6.44928 0.375 6.24813 0.375 6C0.375 5.75187 0.57615 5.55072 0.824281 5.55072H5.55072L5.55072 0.824281C5.55072 0.57615 5.75187 0.375 6 0.375Z"/>
            </svg>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="expandedElements[element]">
          <!-- eslint-disable @angular-eslint/template/no-call-expression -->
          <img
            *ngIf="slice.settings.general.headerIcon.iconExpanded?.image; else defaultIconExpanded"
            alt="Icono expandido"
            [src]="getHeaderIconSrc(slice.settings.general.headerIcon.iconExpanded!.image!)">
          <!-- eslint-enable @angular-eslint/template/no-call-expression -->
          <ng-template #defaultIconExpanded>
            <svg
              viewBox="0 0 12 2"
              fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="black"
                d="M0.375 1.00002C0.375 0.712372 0.581426 0.479187 0.836066 0.479187H11.1639C11.4186 0.479187 11.625 0.712372 11.625 1.00002C11.625 1.28767 11.4186 1.52085 11.1639 1.52085H0.836066C0.581426 1.52085 0.375 1.28767 0.375 1.00002Z"/>
            </svg>
          </ng-template>
        </ng-container>
      </div>
    </div>
    <!-- eslint-disable @angular-eslint/template/no-call-expression -->
    <render-slice-slot
      *ngIf="loadedElements[element]"
      data-e2e="render-slice-slot"
      class="slot"
      [class.visible]="expandedElements[element]"
      [slice]="slice"
      [slot]="(element + 1).toString()"
      [ngStyle]="getSlotStyles(slots[element])">
    </render-slice-slot>
    <!-- eslint-enable @angular-eslint/template/no-call-expression -->
  </div>
</ng-container>
